import ActionButton from '@repo/ui/action-button'
import { DeleteIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { useMutation } from '@tanstack/react-query'
import { Fragment, useState } from 'react'
import { toast } from 'sonner'

import { deleteTripFolderDocument } from '../../../api/trip-folder/delete-trip-folder-document'
import { FileType } from '../../../lib/types/models/file/file'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { queryClient } from '../../../main'

type DeleteTripFolderDocumentButtonProps = {
  folderId: number
  document: FileType
}

const DeleteTripFolderDocumentButton = ({
  folderId,
  document
}: DeleteTripFolderDocumentButtonProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const { mutateAsync: deleteDocument, isPending: isDeleting } = useMutation({
    mutationFn: (documentId: number) => deleteTripFolderDocument(folderId, documentId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['trip-folder-documents', folderId] })
      toast.success('Document supprimé avec succès')
      setIsOpen(false)
    },
    onError: showAxiosError
  })

  return (
    <Fragment>
      <ActionButton
        isLoading={isDeleting}
        variant={'danger'}
        icon={DeleteIcon}
        onClick={() => setIsOpen(true)}
      />

      <Modal
        actionButtonsOptions={{
          confirmText: 'Confirmer',
          cancelText: 'Fermer',
          onConfirm: async () => {
            await deleteDocument(document.id)
          }
        }}
        onCancel={() => setIsOpen(false)}
        isOpen={isOpen}
        title={`Supprimer le document ${document.name}`}
        icon={DeleteIcon}
        isLoading={isDeleting}
        variant={'destructive'}
      />
    </Fragment>
  )
}

export default DeleteTripFolderDocumentButton
